export default __webpack_public_path__ + "static/media/GMAT.e57f936e.png";